// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import vueHeadful from "vue-headful";
import store from "./store";
import App from "./App";
import axios from "axios";
import VueCarousel from "vue-carousel";
import { library } from "@fortawesome/fontawesome-svg-core";
import { iconspro, iconsfree, iconslight } from "./styles/fontawsome";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueObserveVisibility from "vue-observe-visibility";
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
const VueScrollTo = require("vue-scrollto");

library.add(...iconspro, ...iconsfree, ...iconslight);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("vue-headful", vueHeadful);

Vue.use(VueScrollTo);
Vue.use(VueObserveVisibility);
Vue.use(VueCarousel);
Vue.use(BootstrapVue);

window.$ = require("jquery");
window.JQuery = require("jquery");


Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.axios = axios;

export const sessionizeUrl = "https://sessionize.com/api/v2/s49k6k2j/view/"

/* eslint-disable no-new */

new Vue({
  el: "#app",
  store,
  router,
  data: {},
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js